import styled from 'styled-components';
import { darkgrey, grey, white } from 'styles/Colors';

export const EmptySuggestions = styled.div`
  padding: 8px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 9999;
  background-color: ${white};
  min-width: 330px;
`;

export const NoPlayerPlaceholder = styled.div`
  padding: 0 20px;
  font-size: 13px;
  color: ${grey};
  margin-bottom: 10px;
`;

export const NewPlayerInfo = styled.div`
  padding-top: 8px;
  border-top: 1px solid #f5f5f5;
  font-size: 13px;
  margin-bottom: 8px;
`;

export const InputWrapper = styled.div``;

export const FormDetails = styled.div`
  font-size: 13px;
  margin-bottom: 15px;
  color: ${darkgrey};
`;

export const ModalContent = styled.div`
  padding: 25px 32px;
`;

export const SingleRow = styled.div`
  display: flex;
  gap: 0 12px;
  margin-bottom: 30px;
`;
